"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewStakingHelper = void 0;
var subgraph_1 = require("../subgraph");
var bignumber_1 = require("../utils/bignumber");
var multicall_1 = require("@indexed-finance/multicall");
var provider_1 = require("../utils/provider");
var abi_1 = require("@ethersproject/abi");
var RewardsSchedule_json_1 = __importDefault(require("../abi/RewardsSchedule.json"));
var MultiTokenStaking_json_1 = __importDefault(require("../abi/MultiTokenStaking.json"));
var IERC20_json_1 = __importDefault(require("../abi/IERC20.json"));
var bmath_1 = require("../bmath");
var BLOCKS_PER_DAY = 86400 / 13.5;
var NewStakingHelper = /** @class */ (function () {
    function NewStakingHelper(provider, network, stakingPoolInfo, userAddress) {
        this.network = network;
        this.userAddress = userAddress;
        this.lastUpdate = 0;
        this.pools = [];
        this.provider = provider_1.toProvider(provider);
        var pools = stakingPoolInfo.pools, meta = __rest(stakingPoolInfo, ["pools"]);
        this.meta = meta;
        this.pools = pools.map(function (_a) {
            var balance = _a.balance, p = __rest(_a, ["balance"]);
            return (__assign(__assign({}, p), { totalStaked: bignumber_1.toBN(balance), rewardsPerDay: bignumber_1.toBN(0) }));
        });
        this.updatePromise = this.update();
        this.lastUpdate = Math.floor(+new Date() / 1000);
    }
    Object.defineProperty(NewStakingHelper.prototype, "shouldUpdate", {
        get: function () {
            var timestamp = Math.floor(+new Date() / 1000);
            return timestamp - this.lastUpdate > 120;
        },
        enumerable: false,
        configurable: true
    });
    NewStakingHelper.prototype.waitForUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.updatePromise = this.update();
                            this.lastUpdate = Math.floor(+new Date() / 1000);
                        }
                        return [4 /*yield*/, this.updatePromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NewStakingHelper.prototype.setUserAddress = function (address) {
        this.userAddress = address;
        this.updatePromise = this.update();
        this.lastUpdate = Math.floor(+new Date() / 1000);
    };
    NewStakingHelper.create = function (provider, userAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var network, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, provider.getNetwork()];
                    case 1:
                        network = (_a.sent()).chainId === 1 ? 'mainnet' : 'rinkeby';
                        return [4 /*yield*/, subgraph_1.getNewStakingInfo(network)];
                    case 2:
                        info = _a.sent();
                        return [2 /*return*/, new NewStakingHelper(provider, network, info, userAddress)];
                }
            });
        });
    };
    NewStakingHelper.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userAddress, calls, fromBlock, toBlock, MultiTokenStakingInterface, IERC20Interface, _i, _a, pool, multi, halfWay, _b, result0, result1, result, increment, i, rI, pool, poolInfo, allocPoint, userInfo, _c, _d, pool;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        userAddress = this.userAddress;
                        calls = [];
                        fromBlock = __spreadArrays(this.pools).sort(function (a, b) { return b.lastRewardBlock - a.lastRewardBlock; })[0].lastRewardBlock;
                        toBlock = fromBlock + BLOCKS_PER_DAY;
                        calls.push({
                            target: this.meta.rewardsSchedule,
                            function: 'getRewardsForBlockRange',
                            args: [fromBlock, toBlock],
                            interface: new abi_1.Interface(RewardsSchedule_json_1.default)
                        });
                        MultiTokenStakingInterface = new abi_1.Interface(MultiTokenStaking_json_1.default);
                        IERC20Interface = new abi_1.Interface(IERC20_json_1.default);
                        for (_i = 0, _a = this.pools; _i < _a.length; _i++) {
                            pool = _a[_i];
                            calls.push({
                                target: this.meta.id,
                                function: 'poolInfo',
                                args: [pool.id],
                                interface: MultiTokenStakingInterface
                            });
                            calls.push({
                                target: pool.token,
                                function: 'balanceOf',
                                interface: IERC20Interface,
                                args: [this.meta.id]
                            });
                            if (userAddress) {
                                calls.push({
                                    target: this.meta.id,
                                    function: 'userInfo',
                                    args: [pool.id, userAddress],
                                    interface: MultiTokenStakingInterface
                                });
                                calls.push({
                                    target: this.meta.id,
                                    function: 'pendingRewards',
                                    args: [pool.id, userAddress],
                                    interface: MultiTokenStakingInterface
                                });
                                calls.push({
                                    target: pool.token,
                                    function: 'balanceOf',
                                    interface: IERC20Interface,
                                    args: [userAddress]
                                });
                                calls.push({
                                    target: pool.token,
                                    function: 'allowance',
                                    interface: IERC20Interface,
                                    args: [userAddress, this.meta.id]
                                });
                            }
                        }
                        multi = new multicall_1.MultiCall(this.provider);
                        halfWay = Math.floor(calls.length / 2);
                        return [4 /*yield*/, Promise.all([multi.multiCall(calls.slice(0, halfWay)), multi.multiCall(calls.slice(halfWay))])];
                    case 1:
                        _b = _e.sent(), result0 = _b[0], result1 = _b[1];
                        result = __spreadArrays(result0, result1);
                        this.totalRewardsPerDay = bignumber_1.toBN(result[0]);
                        this.meta.totalAllocPoint = 0;
                        increment = userAddress ? 6 : 2;
                        for (i = 0; i < this.pools.length; i++) {
                            rI = i * increment;
                            pool = this.pools[i];
                            poolInfo = result[rI + 1];
                            this.pools[i].lastRewardBlock = +(poolInfo[1]);
                            allocPoint = +(poolInfo[2]);
                            pool.allocPoint = allocPoint;
                            this.meta.totalAllocPoint += allocPoint;
                            pool.totalStaked = bignumber_1.toBN(result[rI + 2]);
                            if (userAddress) {
                                userInfo = result[rI + 3];
                                pool.userStakedBalance = bignumber_1.toBN(userInfo[0]);
                                pool.userEarnedRewards = bignumber_1.toBN(result[rI + 4]);
                                pool.userBalanceStakingToken = bignumber_1.toBN(result[rI + 5]);
                                pool.userAllowanceStakingToken = bignumber_1.toBN(result[rI + 6]);
                            }
                        }
                        for (_c = 0, _d = this.pools; _c < _d.length; _c++) {
                            pool = _d[_c];
                            pool.rewardsPerDay = this.totalRewardsPerDay.times(pool.allocPoint / this.meta.totalAllocPoint);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NewStakingHelper.prototype.calculateTotalRewardsForDuration = function (duration) {
        return this.totalRewardsPerDay.times(duration).div(86400);
    };
    NewStakingHelper.prototype.calculateRewardsForDuration = function (pid, duration, stakedAmount) {
        if (stakedAmount === void 0) { stakedAmount = bmath_1.BONE; }
        var pool = this.pools[pid];
        var staked = bignumber_1.toBN(stakedAmount);
        var poolRewardsForDuration = pool.rewardsPerDay.times(duration).div(86400);
        return poolRewardsForDuration.times(staked).div(pool.totalStaked);
    };
    return NewStakingHelper;
}());
exports.NewStakingHelper = NewStakingHelper;
